/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Google_AdsInputs */

const cs_enum_google_ads = /** @type {(inputs: Enum_Google_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Ads`)
};

const en_enum_google_ads = /** @type {(inputs: Enum_Google_AdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Ads`)
};

/**
* | output |
* | --- |
* | "Google Ads" |
*
* @param {Enum_Google_AdsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_google_ads = /** @type {((inputs?: Enum_Google_AdsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Google_AdsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_google_ads(inputs)
	return cs_enum_google_ads(inputs)
});